require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./mobile-privacy-policy.json") })
        }
      }, "path---mobile-privacy-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---mobile-privacy-policy!./.cache/json/mobile-privacy-policy.json
// module id = 2601
// module chunks = 231608221292675